module.exports = __webpack_public_path__ + "public/Icons/MapMarker/originMarker.png?9c3808d1";